// What a hotel video card shows per status (PLAN.md §33). Pure, so it is unit-tested without rendering.
export type LibraryVideoStatus =
  | "reserved" | "uploading" | "completing" | "uploaded" | "processing" | "ready" | "failed" | "rejected" | "aborted" | "deleting"

export type LibraryVideo = {
  id: string
  status: LibraryVideoStatus
  originalName: string
  message: string | null
  pillarName: string | null
  durationMs: number | null
  width: number | null
  height: number | null
  errorCode: string | null
  createdAt: string
  readyAt: string | null
  videoUrl: string | null
  posterUrl: string | null
  urlExpiresAt: string | null
}

export type VideoCardState = {
  label: string
  tone: "ok" | "busy" | "error"
  busy: boolean
  playable: boolean
  hint: string
}

const REJECT_HINTS: Record<string, string> = {
  too_long: "Das Video ist zu lang (max. 3 Minuten). Bitte kürzen und erneut hochladen.",
  no_video: "Die Datei enthält kein abspielbares Video.",
}

export function videoCardState(v: Pick<LibraryVideo, "status" | "errorCode" | "videoUrl">): VideoCardState {
  switch (v.status) {
    case "ready":
      return { label: "Bereit", tone: "ok", busy: false, playable: !!v.videoUrl, hint: "" }
    case "reserved":
    case "uploading":
    case "completing":
      return { label: "Wird hochgeladen", tone: "busy", busy: true, playable: false, hint: "" }
    case "uploaded":
    case "processing":
      return { label: "Wird verarbeitet", tone: "busy", busy: true, playable: false, hint: "" }
    case "rejected":
      return {
        label: "Abgelehnt", tone: "error", busy: false, playable: false,
        hint: (v.errorCode && REJECT_HINTS[v.errorCode]) || "Dieses Video konnte nicht angenommen werden.",
      }
    case "aborted":
      return { label: "Abgebrochen", tone: "error", busy: false, playable: false, hint: "Der Upload wurde nicht abgeschlossen. Bitte erneut hochladen." }
    case "failed":
    default:
      return { label: "Fehlgeschlagen", tone: "error", busy: false, playable: false, hint: "Konnte nicht verarbeitet werden, bitte erneut hochladen." }
  }
}

export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.round(ms / 1000))
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`
}
